import React, { useContext } from "react";
import SupplierVendorAddresses from "../SupplierVendorAddresses/SupplierVendorAddresses";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {};

export const SupplierVendorAddressesWrapper = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const navigate = useNavigate();
    const location = useLocation();
    const match = useMatch("/:entityType/:guid/addresses"); // how can this be setup as a wildcard for customer (dealer, etc.)

    console.log(match);

    return (
        <SupplierVendorAddresses
            socket={socket}
            setActivityIndicator={uiContext.setActivityIndicator}
            notifyFn={uiContext.notifyFn}
            setSidebarComponent={uiContext.setSidebarComponent}
            toggleSidebar={uiContext.toggleSidebar}
            supplierModel={supplierModel}
            userModel={userModel}
            history={navigate}
            location={location}
            match={match}
        />
    );
};
